module.exports = __webpack_public_path__ + "img/erp-logos_0021_quickbooks.03891304.jpg";